import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthContext } from '../../contexts/AuthContext.jsx';
import { login as loginRequest } from '../../services/api/auth.js';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cargando, setCargando] = useState(false);
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setCargando(true);
    try {
      const { token, user } = await loginRequest(email, password);
      loginUser(token, user);
      Swal.fire({ position: 'center', icon: 'success', title: 'Bienvenido', showConfirmButton: false, timer: 2000 });
      navigate('/');
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!', footer: error.message || 'No se pudo iniciar sesión. Intenta de nuevo.' });
    } finally {
      setCargando(false);
    }
  };

  // Réplica de V1 (`Login.jsx`): tarjeta con el logo Sistemify arriba, Email / Password en
  // dos columnas y botón "Login" a la derecha (color #003A5C).
  return (
    <div className="min-h-screen bg-slate-50 px-4 pt-12">
      <div className="w-full max-w-2xl mx-auto card overflow-hidden">
        <img src="/Logo-Sistemify-Login.png" alt="auto" className="w-full" />
        <form onSubmit={handleSubmit} className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="label">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="type your email" className="input-base" />
            </div>
            <div>
              <label className="label">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="type your password here" className="input-base" />
            </div>
          </div>
          <div className="mt-4 flex justify-end">
            <button type="submit" disabled={cargando} className="px-4 py-2 rounded-lg text-white font-medium disabled:opacity-60" style={{ backgroundColor: '#003A5C' }}>
              {cargando ? 'Login...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
